const getNameTransaction = (value: string) => value.replaceAll('_', ' ');

const getNameFinancial = (value: string) => {
  let name: string;

  switch (value) {
    case 'averageEmoney':
      name = 'Average outstanding e-money (180 days)';
      break;
    case 'excessEligibleEquity':
      name = 'Excess eligible equity';
      break;
    case 'currentSafeguardedFunds':
      name = 'Current safeguarded funds';
      break;
    case 'currentEmoney':
      name = 'Current outstanding e-money.';
      break;
    case 'netShareholderAssets':
      name = 'Eligible equity';
      break;
    case 'profitLoss':
      name = 'Profit & Loss';
      break;
    case 'totalIncomingFunds':
      name = 'Total incoming funds';
      break;
    case 'totalOutgoingFunds':
      name = 'Total outgoing funds';
      break;
    default:
      name = value;
      break;
  }
  return name;
};

const getNameCustomer = (value: string) => {
  let name: string;

  switch (value) {
    case 'ACCEPTED':
      name = 'Accepted applications';
      break;
    case 'DECLINED':
      name = 'Declined applications';
      break;
    case 'INCOMPLETE':
      name = 'Incomplete applications';
      break;
    case 'SUBMITTED':
      name = 'Submitted applications';
      break;
    case 'READY_TO_REVIEW':
      name = 'Ready to review';
      break;
    case 'REVIEW_IN_PROGRESS':
      name = 'Review in progress';
      break;
    default:
      name = value;
      break;
  }
  return name;
};

const getNamePaymentType = (value: string) => value.replaceAll('_', ' ');

export {
  getNameTransaction,
  getNameFinancial,
  getNameCustomer,
  getNamePaymentType,
};
